
import { useTheme } from '@mui/material';
import { ILegendPost } from './Legend';
import EDTooltip from '../../BaseComponents/Tooltip/EDTooltip';
import { makeStyles } from 'tss-react/mui';
import { CommonPropsAndTypes } from '../../BaseComponents/_Types/StandardComponentProps';

interface IProps {
  legendData: ILegendPost;
  className?: string;
  noMargin?: boolean;
  notSpaced?: boolean;
}

const useStyles = makeStyles()({
  legendBoxMargin: {
    marginRight: 4,
  },
  legendBoxSpaced: {
    marginTop: 4,
  },
} as const);

const LegendBox: React.FC<React.PropsWithChildren<IProps>> = props => {
  const theme = useTheme();
  const { classes, cx } = useStyles();
  const greyBoxOrStriped: boolean =
    !!props.legendData.greyBox || !!props.legendData.striped;
  const legendColor: CommonPropsAndTypes.LegendColorType =
    props.legendData.color ?? 'gray';
  return (
    <EDTooltip title={props.legendData.caption}>
      <div
        className={cx(props.className, {
          [classes.legendBoxMargin]: !props.noMargin,
          [classes.legendBoxSpaced]: !props.notSpaced,
        })}
        style={{
          background: greyBoxOrStriped
            ? 'white'
            : theme.customProperties.Legend[legendColor][
                props.legendData.colorOpacity ?? 'full'
              ],
          border: `1px solid ${
            theme.customProperties.Legend[legendColor][
              props.legendData.colorOpacity ?? 'full'
            ]
          }`,
          borderRadius: 4,
          width: 14,
          height: 14,
        }}
      />
    </EDTooltip>
  );
};

export default LegendBox;
